import { useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { images } from '../data/images';
import { buildSchema } from '../utils/schema';
export function SeoHead() {
  const {
    t,
    lang
  } = useLanguage();
  useEffect(() => {
    document.title = t.seo.title;
    setMeta('name', 'description', t.seo.description);
    setMeta('property', 'og:title', t.seo.title);
    setMeta('property', 'og:description', t.seo.description);
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:image', images.hero);
    setMeta('property', 'og:locale', lang === 'es' ? 'es_US' : 'en_US');
    setMeta('name', 'twitter:card', 'summary_large_image');
    let script = document.getElementById('alma-jsonld') as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = 'alma-jsonld';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(buildSchema(t, lang));
  }, [t, lang]);
  return null;
}
function setMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}